export const TASKS_FAN_LIST_FIRST_PAGE = 1
// Multiple of the 4 / 3 / 2 feed columns, so a page ends on a full row.
export const TASKS_AVAILABLE_PAGE_SIZE = 24
